// import { isEmpty } from 'ramda';
import { IFilterProps } from '../../../components/RealtyValuation';
import { IPricesFiltersState } from '../../../types/developerValuation/pricesFiltersState';
import {
  IDeveloperValuationFilters,
  TBuildingClass,
  TPeriod,
  TRoomCount,
} from '../../../types/developerValuation/developerValuationFilters';
import { IRegion } from '../../../types/regions';

const mapFilterToLabel: Record<keyof IPricesFiltersState, string> = {
  roomCount: 'Количество комнат',
  period: 'Период',
  buildingClass: 'Класс жилого комплекса',
  regionId: 'Регион',
};

const mapBuildingFilterToLabel: Record<TBuildingClass, string> = {
  business: 'Бизнес',
  comfort: 'Комфорт',
  econom: 'Эконом',
  premium: 'Премиум',
};

const mapPeriodsFilterToLabel: Record<TPeriod, string> = {
  allTime: 'Всё время',
  halfYear: 'Полгода',
  year: 'Год',
};

const mapRoomCountFilterToLabel: Record<TRoomCount, string> = {
  fourRoom: '4+',
  oneRoom: '1',
  studio: 'Студия',
  threeRoom: '3',
  twoRoom: '2',
};

export interface IPreparedFiltersProps {
  filtersData: IDeveloperValuationFilters;
  regions: IRegion[];
  /* eslint-disable @typescript-eslint/no-explicit-any */
  onChange(filterName: keyof IPricesFiltersState, filterValue: any): void;
}

export function getPreparedFiltersProps({ filtersData, onChange, regions }: IPreparedFiltersProps): IFilterProps[] {
  const filterProps = [];

  if (filtersData.availableRegionIds?.length) {
    const regionsMap = regions.reduce(
      (acc, item) => {
        acc[item.id] = item.name;

        return acc;
      },
      {} as Record<number, string>,
    );

    const options = filtersData.availableRegionIds.map((item: number) => ({
      value: item,
      label: regionsMap[item],
    }));

    filterProps.push({
      label: mapFilterToLabel['regionId'],
      options,
      value: filtersData.activeRegionId,
      onChange(_: React.ChangeEvent<HTMLInputElement>, item: TBuildingClass) {
        onChange('regionId', item);
      },
    });
  }

  if (filtersData.availableBuildingClass?.length) {
    const options = filtersData.availableBuildingClass.map((item: TBuildingClass) => ({
      value: item,
      label: mapBuildingFilterToLabel[item],
    }));

    filterProps.push({
      label: mapFilterToLabel['buildingClass'],
      options,
      value: filtersData.activeBuildingClass[0],
      onChange(_: React.ChangeEvent<HTMLInputElement>, item: TBuildingClass) {
        onChange('buildingClass', item);
      },
    });
  }

  if (filtersData.availablePeriods?.length) {
    const options = filtersData.availablePeriods.map((item: TPeriod) => ({
      value: item,
      label: mapPeriodsFilterToLabel[item],
    }));

    filterProps.push({
      label: mapFilterToLabel['period'],
      options,
      value: filtersData.activePeriod,
      onChange(_: React.ChangeEvent<HTMLInputElement>, item: TPeriod) {
        onChange('period', item);
      },
    });
  }

  if (filtersData.availableRoomCount?.length) {
    const options = filtersData.availableRoomCount.map((item: TRoomCount) => ({
      value: item,
      label: mapRoomCountFilterToLabel[item],
    }));

    filterProps.push({
      label: mapFilterToLabel['roomCount'],
      options,
      value: filtersData.activeRoomCount[0],
      onChange(_: React.ChangeEvent<HTMLInputElement>, item: TRoomCount) {
        onChange('roomCount', item);
      },
    });
  }

  return filterProps;
}
